'use strict';
import template from './landing-page-content.component.html';

export default {
	bindings: {
		widget: '=',
		view: '=',
		model: '=',
	},
	controller: MxCommonLandingPageContentCtrl,
	controllerAs: 'vm',
	template: template,
};

MxCommonLandingPageContentCtrl.$inject = [
	'$scope',
	'$window',

	'$interpolate',
	'mx.SolutionBuilderAgent.DashboardWidgetDataService',
	'mx.shell.NotificationService',
	'mx.shell.ActionManagerService',
	'mx.shell.ActionExecutorService',
	'mx.internationalization',
];
export function MxCommonLandingPageContentCtrl($scope, $window, $interpolate, dashboardDataService, notificationService, actionManagerService, actionExecutorService, i18n) {
	const vm = this;

	vm.$onInit = function () {
		var MOBILE_BREAKPOINT = 1024;

		if (!vm.widget || !vm.view) {
			mx.console.warn('no input parameters for landing page');
			return;
		}
		vm.dataModel = vm.model;
		vm.dashboardId = vm.widget.id;

		vm.gridOptions = {
			mobileModeEnabled: true,
			mobileBreakPoint: MOBILE_BREAKPOINT,
			columns: 10,
			maxSizeX: 10,
			maxSizeY: 100,
			margins: [15, 15],
			colWidth: 'auto',
		};

		vm.dashboardDataService = dashboardDataService;
		vm.dashboardPublicFunctions = {};

		var config = getLandingConfig();
		var result = dashboardDataService.initDashboard(vm.dashboardId, config.widgets, config.defaultLayout, vm.dashboardPublicFunctions);

		if (result.isCustomized && result.isSetOfWidgetsChanged) {
			notificationService
				.confirm(
					i18n.get('solutionBuilderAgent.layouts.landing-page.landing-page-content.newWidgetConfirmTitle'),
					i18n.get('solutionBuilderAgent.layouts.landing-page.landing-page-content.newWidgetConfirmText'),
					i18n.get('solutionBuilderAgent.layouts.landing-page.landing-page-content.newWidgetConfirmYes'),
					i18n.get('solutionBuilderAgent.layouts.landing-page.landing-page-content.newWidgetConfirmNo')
				)
				.then(function () {
					actionManagerService.getAllActions().then(function (actions) {
						if (!Array.isArray(actions)) {
							return;
						}
						actions.forEach(function (action) {
							if (action.name === 'pandora.PDRLandingPageWidget.edit-dashboard') {
								actionExecutorService.execute(action).catch(mx.logCatch);
							}
						});
					});
				});
		}

		vm.loaded = true;
	};

	function getLandingConfig() {
		var widgets = [];
		var defaultLayout = [];

		var widgetsHTML = document.createElement('div');

		widgetsHTML.innerHTML = vm.widget.views[0].Template;

		for (var i = 0; i < widgetsHTML.children.length; i++) {
			const widget = widgetsHTML.children[i];
			if (widget.tagName.toLowerCase() === 'mx-dashboard-config') {
				vm.widgetsOpacity = parseInt(widget.getAttribute('widget-opacity')) / 100;

				vm.backgroundStyle = {
					'background-color': widget.getAttribute('background-color'),
					'background-size': '100% 100%',
					'background-image': 'url(' + widget.getAttribute('background-image') + ')',
					opacity: parseInt(widget.getAttribute('background-opacity')) / 100,
				};
				continue;
			}
			const id = widget.getAttribute('id');
			const added = widget.getAttribute('visible') !== 'false';
			const availableAttr = widget.getAttribute('available') || '';
			const available = availableAttr !== 'false';

			widgets.push({
				id: id,
				type: 'Custom',
				available: available,
				added: added,
				content: widget.innerHTML,
				params: {
					dashboardId: vm.dashboardId,
					gridOptions: vm.gridOptions,
					size: {
						w: widget.getAttribute('sizeX'),
						h: widget.getAttribute('sizeY'),
					},
					title: $interpolate(widget.getAttribute('title'))($scope),
					description: $interpolate(widget.getAttribute('description'))($scope),
					style: widget.getAttribute('style') || '',
					class: widget.getAttribute('class'),
					// Might fix auto tests
					icon: widget.getAttribute('icon') || 'dashboard',
				},
				frame: {
					origin: {
						x: Number(widget.getAttribute('posX')),
						y: Number(widget.getAttribute('posY')),
					},
					size: {
						w: Number(widget.getAttribute('sizeX')),
						h: Number(widget.getAttribute('sizeY')),
					},
				},
			});

			defaultLayout.push({
				id: id,
				added: added,
				frame: {
					origin: {
						x: Number(widget.getAttribute('posX')),
						y: Number(widget.getAttribute('posY')),
					},
					size: {
						w: Number(widget.getAttribute('sizeX')),
						h: Number(widget.getAttribute('sizeY')),
					},
				},
			});

			const availableMatch = availableAttr.match(/^{{(.*)}}$/);
			if (availableMatch) {
				$scope.$watch(availableMatch[1], function (isAvailable) {
					if (isAvailable) {
						dashboardDataService.addWidgetToDashboard(vm.dashboardId, id, true);
					} else {
						dashboardDataService.removeWidgetFromDashboard(vm.dashboardId, id, true);
					}
				});
			}
		}

		// This sort is needed to have more predictable focus order by tab-key
		widgets.sort((a, b) => {
			const aY = a.frame?.origin?.y || 0;
			const bY = b.frame?.origin?.y || 0;
			const aX = a.frame?.origin?.x || 0;
			const bX = b.frame?.origin?.x || 0;
			return aY - bY || aX - bX;
		});

		if ($window.innerWidth < 960) {
			defaultLayout.forEach(function (layout) {
				layout.backupW = layout.frame.size.w;
				layout.backupY = layout.frame.origin.y;
				layout.backupX = layout.frame.origin.x;
			});

			if ($window.innerWidth <= 600) {
				defaultLayout.forEach(function (layout) {
					layout.frame.size.w = 3;
				});
			} else if ($window.innerWidth >= 600 && $window.innerWidth <= 960) {
				defaultLayout.forEach(function (layout) {
					if (layout.frame.size.w > 6) {
						layout.frame.size.w = 6;
					}
					delete layout.frame.origin.y;
					delete layout.frame.origin.x;
				});
			}

			var _resizeHandler = $.debounce(1000, function () {
				$scope.$evalAsync(function () {
					var windowWidth = $window.innerWidth;
					if (windowWidth <= 600) {
						defaultLayout.forEach(function (layout) {
							layout.frame.origin.y = layout.backupY;
							layout.frame.origin.x = layout.backupX;
							layout.frame.size.w = 3;
						});
					} else if (windowWidth >= 600 && windowWidth <= 960) {
						defaultLayout.forEach(function (layout) {
							layout.frame.size.w = layout.backupW;
							if (layout.frame.size.w > 6) {
								layout.frame.size.w = 6;
							}
							delete layout.frame.origin.y;
							delete layout.frame.origin.x;
						});
					}
					dashboardDataService.setDashboardLayout(vm.dashboardId, defaultLayout);
					dashboardDataService.renderDashboard(vm.dashboardId);
				});
			});
			$($window).on('resize', _resizeHandler);
			_resizeHandler();
		}

		return {
			widgets: widgets,
			defaultLayout: defaultLayout,
		};
	}
}

Object.defineProperty(MxCommonLandingPageContentCtrl.prototype, 'editMode', {
	enumerable: true,
	configurable: false,
	get: function () {
		return this.dashboardDataService.isDashboardEditable(this.dashboardId);
	},
});
